import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submenuItem", "submenuContent"]

  connect() {
    this.currentActiveIndex = null
  }

  showSubmenu(event) {
    const menuItem = event.currentTarget
    const index = menuItem.dataset.submenuIndex

    // 如果没有二级菜单，不做任何处理
    if (!menuItem.dataset.hasSubmenu) {
      this.hideAllSubmenus()
      return
    }

    // 隐藏所有二级菜单内容
    this.submenuContentTargets.forEach(content => {
      content.classList.add('hidden')
    })

    // 显示对应的二级菜单
    const submenuToShow = this.submenuContentTargets.find(
      content => content.dataset.submenuIndex === index
    )

    if (submenuToShow) {
      submenuToShow.classList.remove('hidden')
      this.currentActiveIndex = index
    }
  }

  hideAllSubmenus() {
    this.submenuContentTargets.forEach(content => {
      content.classList.add('hidden')
    })
    this.currentActiveIndex = null
  }
}

